import { render, staticRenderFns } from "./ListaCategoria.vue?vue&type=template&id=d5a597d2"
import script from "./ListaCategoria.vue?vue&type=script&lang=js"
export * from "./ListaCategoria.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports